import { observer } from "mobx-react";
import { UsersViewModel } from "../UsersView/UsersView";
import BaseComponent from "../../../utility/BaseComponent";
import * as React from "react";
import { Button, CircularProgress } from "react-md";
import "./static/ResultsView.scss";
import { observable, action, runInAction } from "mobx";
import { IResultsAnalytics } from "../../../utility/admin/UsersControls/UsersAnalytics/IResultsAnalytics";
import { TimeSpan } from "../../../utility/admin/UsersControls/UsersAnalytics/IUsersAnalytics";
import { isNullOrUndefined } from "util";
import ResultsAnalyticsView , { ResultsAnalyticsViewModel } from "./ResultsAnalyticsView/ResultsAnalyticsView";
import ResultsTableView, { ResultsTableViewModel } from "./ResultsTableView/ResultsTableView";
import * as moment from 'moment';

export class ResultsViewModel extends UsersViewModel {
    @observable raised: string = "All";
    @observable resultsAnalytics: IResultsAnalytics;
    @observable selectedTimeSpan: TimeSpan = TimeSpan.ALL;
    @action.bound
    onTimeSpanChanged(span: TimeSpan) {
        this.selectedTimeSpan = span;
        this.prepare();
    }
    @action.bound
    prepare() {
        this.incrementAsyncOperations();
        let controls = this.services.getAdminServicesProvider().getUsersControls();
        let date = moment().toDate();
        controls.getResultsAnalytics(
            this.selectedTimeSpan,
            this.selectedTimeSpan === TimeSpan.MONTH ? date.getMonth() : undefined,
            (this.selectedTimeSpan === TimeSpan.MONTH || this.selectedTimeSpan === TimeSpan.YEAR  ) ?
            date.getFullYear() : undefined 
        )
        .first()
        .subscribe(
            item => {
                if (this.asyncOperationsCount > 0) {
                    this.decrementAsyncOperations();
                }
                runInAction( () => {
                    this.resultsAnalytics = item;
                });
            },
            error => {
                // tslint:disable-next-line:no-console
                console.log(error);
            }
        );
    }
}
@observer class ResultsView extends BaseComponent<{model: ResultsViewModel}, {}> {
      
    render() {
        return(
            <div className="ResultsViewContainer GeneralViewContainer">
                <div className="row">
                {
                    !isNullOrUndefined(this.props.model.resultsAnalytics) &&   
                    <div className="ResultsViewAnalyticsHeader">
                        <h2>Overview</h2>
                        <div className='HeaderDateSwitch'>
                        {
                            isNullOrUndefined(this.props.model.resultsAnalytics) &&
                            <CircularProgress id="primary" centered={true} />
                        }
                         {
                            !isNullOrUndefined(this.props.model.resultsAnalytics) &&   
                            <div>
                        <Button 
                            secondary={this.props.model.raised === "This Month"} 
                            flat={this.props.model.raised !== "This Month"}  
                            raised={this.props.model.raised === "This Month"} 
                            onClick={() => {
                                this.props.model.onTimeSpanChanged(TimeSpan.MONTH);
                                this.props.model.raised = "This Month";
                            } }
                        >
                        This Month
                        </Button>
                        <Button 
                            secondary={this.props.model.raised === "This Year"} 
                            flat={this.props.model.raised !== "This Year"}  
                            raised={this.props.model.raised === "This Year"} 
                            onClick={() => {
                                this.props.model.onTimeSpanChanged(TimeSpan.YEAR);
                                this.props.model.raised = "This Year";
                            } }
                        >
                        This Year
                        </Button>
                        <Button 
                            secondary={this.props.model.raised === "All"} 
                            flat={this.props.model.raised !== "All"}  
                            raised={this.props.model.raised === "All"}
                            onClick={() => {
                                this.props.model.onTimeSpanChanged(TimeSpan.ALL);
                                this.props.model.raised = "All";
                            } }
                        >
                        ALL
                        </Button>
                        </div>
                         }
                        </div>
                    </div>
                }
                {
                    !isNullOrUndefined(this.props.model.resultsAnalytics) &&   
                    <ResultsAnalyticsView 
                        model={new ResultsAnalyticsViewModel(this.props.model.
                        resultsAnalytics)}
                    />
                }
                </div>

                <div className="row">
                    <h2>Results</h2>
                    {
                        isNullOrUndefined(this.props.model.resultsAnalytics) &&
                        <CircularProgress id="primary" centered={true} />
                    }
                    {
                        !isNullOrUndefined(this.props.model.resultsAnalytics) &&
                        <ResultsTableView 
                            model={new ResultsTableViewModel
                            (this.props.model.resultsAnalytics.results, 
                             this.props.model.services.getAdminServicesProvider().getUsersControls().getOperations(),
                             this.props.model.services.getOrganisation().code,
                             this.props.model.services.getOrganisation().isPublic)}
                        />
                    }       
                </div>
            </div>
        );
    }
}
export default ResultsView;


// WEBPACK FOOTER //
// ./src/view/Admin/ResultsView/ResultsView.tsx